'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  var path = [action.feis_id];

  var purchasedProductsByAccount = [action.feis_id, action.acct_id];

  switch (action.type) {

    case 'GET_PRODUCTS_START':
      {
        return state.setIn(path, (0, _immutable.fromJS)({ 'loading': true }));
      }

    case 'GET_PRODUCTS':
      return state.setIn(path, (0, _immutable.fromJS)(action.payload.map(function (p) {
        return p.id;
      })));

    case 'ADD_PRODUCT':
      {
        return state.setIn(path, state.getIn(path).push((0, _immutable.fromJS)(action.payload.id)));
      }

    case 'GET_PURCHASED_PRODUCTS_BY_ACCOUNT_FOR_FEIS':
      return state.setIn(purchasedProductsByAccount, (0, _immutable.fromJS)(action.payload.map(function (p) {
        return p.id;
      })));

    case 'PURCHASE_PRODUCT':
      {
        return state.setIn(purchasedProductsByAccount, (state.getIn(purchasedProductsByAccount) || (0, _immutable.List)()).filter(function (pid) {
          return pid !== action.payload.id;
        }).push((0, _immutable.fromJS)(action.payload.id)));
      }

    case 'RETURN_PRODUCT':
      {
        return state.setIn(purchasedProductsByAccount, (state.getIn(purchasedProductsByAccount) || (0, _immutable.List)()).filter(function (pid) {
          return pid !== action.purchase_id;
        }));
      }

    case 'DELETE_PRODUCT':
      return state.setIn(path, state.getIn(path).filter(function (p) {
        return p !== action.product_id;
      }));

    case 'DELETE_UI_PRODUCTS':
      return state.deleteIn(path);

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/feiseanna/products/index.js
// module id = 700
// module chunks = 0